import Vue from "vue";
import VueI18n from "vue-i18n";

const filterJoin = (value: Array<string | VueI18n.TranslateResult>): string => {
  return value.join(" ");
};

Vue.filter("join", filterJoin);

export { filterJoin };
